<template>
  <div id="app">
  <headerComponent @city="city" v-bind:class="{'cabinet__header' : this.$route.path.split('/')[1] === 'cabinet'}" />
    <router-view :cityBanner="banner_city"  />
    <footerComponent v-bind:class="{'cabinet__header' : this.$route.path.split('/')[1] === 'cabinet'}" />
    <a id="back-to-top" href="" class="btn btn-lg back-to-top" role="button" :title="$t('text_10')" data-toggle="tooltip" data-placement="left"><img src="@/assets/img/icon/up.png" alt=""></a>
  </div>
</template>

<script>
import headerComponent from '@/components/headerComponent.vue'
import footerComponent from '@/components/footerComponent.vue'
export default {
  name: 'App',
  components: {
    headerComponent,
    footerComponent
  },
  data () {
    return {
      banner_city: ''
    }
  },
  watch: {
    $route (to, from) {
      localStorage.removeItem('auto')
      localStorage.removeItem('mech')
      localStorage.removeItem('jewellery')
    }
  },
  mounted () {
    // scroll
    $(document).ready(function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
          $('#back-to-top').fadeIn()
        } else {
          $('#back-to-top').fadeOut()
        }
      })
      // scroll body to 0px on click
      $('#back-to-top').click(function () {
        $('#back-to-top').tooltip('hide')
        $('body,html').animate({
          scrollTop: 0
        }, 800)
        return false
      })

      $('#back-to-top').tooltip('show')
    })
  },
  methods: {
    city (value) {
      this.banner_city = value
    }
  }
}
</script>

<style>
  @import './assets/css/bootstrap.min.css';
  @import './assets/font-awesome-4.7.0/css/font-awesome.min.css';
  @import './assets/slick/slick.css';
  @import './assets/slick/slick-theme.css';
  @import './assets/css/fonts.css';
  @import './assets/css/style.css';
  @import './assets/css/media.css';
  @import 'vue-lazy-youtube-video/dist/style.css';
</style>



// WEBPACK FOOTER //
// src/App.vue